  <div class="role-list-container">
    <div class="custom-container">
      <!-- <mat-icon color="primary" class="back-arrow" [routerLink]="'/dashboardAdmin'">arrow_back</mat-icon> -->
      <mat-card class="alarm-card">
        <mat-card-content>
          <h1>Control de Permisos</h1>
          <generic-table
            [columnHeader]="columnHeader"
            [service]="roleService"
            [controllerName]="controllerName"
            [hasInactives]="hasInactives"
            [hasEditables]="hasEditables"
            [hasDeletables]="hasDeletables"
            [filterOptions]="filterOptions"
            [catalogPaginationRequest]="catalogPaginationRequest"
          >
          </generic-table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>